const SIGNIN_TEXT = 'Sign In';
const SIGNOUT_TEXT = 'Sign Out';

export default { SIGNIN_TEXT, SIGNOUT_TEXT };
